export default "__VITE_ASSET__nnP8jYv7__"